﻿const Redirect = require('./redirect');

const ACCESS_TOKEN_KEY = 'access-token';
const REFRESH_TOKEN_KEY = 'refresh-token';
const DEFAULT_PAGE = '/';
const LOGIN_PAGE = '/login';

function isOnLoginPage() {
    var curPage = Redirect.getCurrentUrl();
    var argsStartIndex = curPage.indexOf('?');
    if (argsStartIndex > 0) {
        curPage = curPage.substr(0, argsStartIndex);
    }
    while (curPage.endsWith('/')) {
        curPage = curPage.substr(0, curPage.length - 1);
    }
    return curPage.endsWith(LOGIN_PAGE);
}

function getSessionAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
}

function getSessionRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
}

function restoreSession(accessToken, refreshToken, needRedirect) {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    if (needRedirect) {
        Redirect.redirect(DEFAULT_PAGE);
    }
}

function stopSession() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    Redirect.redirect(LOGIN_PAGE);
}

module.exports = {
    isOnLoginPage: isOnLoginPage,
    getSessionAccessToken: getSessionAccessToken,
    getSessionRefreshToken: getSessionRefreshToken,
    restoreSession: restoreSession,
    stopSession: stopSession
};


//////////////////
// WEBPACK FOOTER
// ./App/services/session.js
// module id = 368
// module chunks = 0